<template>
  <v-row>
    <v-col cols="12" v-if="navState" align="center" xs="12">
      <v-icon color="primary" class="mb-2 handpointer" @click="navigate(-1)">chevron_left</v-icon>{{navState.index + 1}} von {{navState.list.length}}<v-icon color="primary" class="mb-2 handpointer" @click="navigate(1)">chevron_right</v-icon>
    </v-col>
    <v-col cols="12" xs="12" md="6" v-if="device && companyData">
      <v-row>
        <v-col cols="12" xs="12" sm="3">
          <v-text-field label="Letzte Rückmeldung" readonly v-model="device.heartbeatDateTime"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="2">
          <v-text-field label="Status" readonly v-model="device.deviceState"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4">
          <v-text-field label="Name des Reisebüros" v-model="companyData.name"></v-text-field>
        </v-col>
        <v-col>
          <v-switch
              v-model="device.isService"
              :false-value="0"
              :true-value="1"
              label="Service"
          ></v-switch>
        </v-col>

      </v-row>
      <v-row v-if="companyData">
        <v-col cols="12" xs="12" sm="4">
          <v-text-field label="Ansprechpartner" v-model="companyData.contactPerson" dense></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" >
          <v-text-field label="E-Mail" dense v-model="companyData.email"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4">
          <v-text-field label="Tel." v-model="companyData.phonenumber" dense></v-text-field>
        </v-col>
        <v-col align="end" cols="12" xs="12">
          <v-btn @click="sendEmail()" color="primary" class="mt-3 mr-4">
            <v-icon class="mr-3">email</v-icon>
            E-Mail
          </v-btn>
        </v-col>

        <v-col cols="12" xs="12" sm="5">
          <v-text-field label="Straße" v-model="companyData.street" dense></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="3">
          <v-text-field label="Plz:" v-model="companyData.postcode" dense></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4">
          <v-text-field label="Ort" v-model="companyData.city" dense></v-text-field>
        </v-col>
        <v-col cols="12" xs="12">
          <v-text-field label="Sonstiges" v-model="companyData.comment" dense></v-text-field>
        </v-col>
      </v-row>
      <v-expansion-panels v-if="companyData">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Display / Stele ({{device.display}} / {{device.displaySer}} / {{device.stele}})
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="pa-4">
              <v-col cols="12" sm="4">
                <v-text-field v-model="device.display" label="Display Typ" clearable dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="device.displaySer" label="Display Ser" clearable dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="device.stele" label="Stele" clearable dense></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Player ({{device.playerTyp}} / {{device.playerMac}} / {{device.playerSer}})
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="pa-4">
              <v-col cols="12" sm="4">
                <v-text-field v-model="device.playerTyp" label="Player Typ" clearable dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="device.playerMac" label="Player Mac" clearable dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="device.playerSer" label="Player Ser" clearable dense></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Netzwerk ({{device.netip}} / {{device.netsub}} / {{device.netgateway}} / {{device.proxy}})
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="6">
                <v-text-field label="IP Adresse" v-model="device.netip" clearable dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Sub Adresse" v-model="device.netsub" clearable dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Gateway" v-model="device.netgateway" clearable dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Proxy" v-model="device.proxy" clearable dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="DNS1" v-model="device.dns1" clearable dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="DNS2" v-model="device.dns2" clearable dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Zugangsart" v-model="device.inputType" dense></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col v-if="!isDeviceArchived()">
          <v-btn @click="doArchive()" :disabled="isSaving || isArchiving" :loading="isArchiving" color="success" class="mt-3">
            <v-icon class="mr-3">archive</v-icon>
            Archivieren
          </v-btn>
        </v-col>
        <v-col v-else>
          <v-btn color="failure" class="mt-3" v-if="isAdmin()" :disabled="isSaving || isArchiving" :loading="isArchiving" @click="unArchive()">
            <v-icon class="mr-3">unarchive</v-icon>
            <span style="color: red">Reaktivieren</span>
          </v-btn>
          <v-btn v-else color="success" class="mt-3" disabled>
            <v-icon class="mr-3">archive</v-icon>
            Ist Archiviert
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col align="end">
          <v-btn @click="updateItem()" :disabled="isSaving || isArchiving" :loading="isSaving" color="primary" class="mt-3">
            <v-icon class="mr-3">save</v-icon>Speichern
          </v-btn>
        </v-col>
      </v-row>

    </v-col>
    <v-col cols="12" xs="12" md="6" class="pt-0" v-if="device && device.guid">
      <TableComments ref="tableComments" :tagList="tagList" :deviceId="device.guid" :companyId="'' + companyId"></TableComments>
    </v-col>
    <DialogSendEmail ref="dlgEMail" @sendMail="doSendMail"></DialogSendEmail>
  </v-row>

</template>

<script>

import TableComments from "@/components/tables/TableComments";
import DialogSendEmail from "@/components/dialogs/DialogSendEmail";
// import _ from "lodash";
import Vue from "vue";
import _ from "lodash";

export default {
  name: "TabSupport",
  props: ['device', 'companyId', 'tagList'],
  components: {TableComments, DialogSendEmail},
  data() {
    return {
      navState: null,
      companyData: null,
      isSaving: false,
      isArchiving: false,
    }
  },
  methods: {
    getIndicatorIndex: function (item) {
      const diff = new Date().getTime() - item.lastHeartbeat
      if (diff >= 60 * 24 * 60000) {
        return 2
      }
      return 0
    },
    doSendMail: function (item) {
      console.log('doSendMail', item)
      var mail = null
      var cmp = this
      if (item.extra) {
        mail = []
        _.forEach(item.extra, function (device) {
          if (device.checked) {
            let txtHtml = '<br><br>'
            let txt = ''
            _.forEach(device.devices, function (d) {
              txt += d.name + ' '
              txtHtml += d.name + '\n<br>'
            })
            const newMessage = item.message.replace("[EXTRA_DATA]", txtHtml)
            const newSubject = item.subject.replace("[EXTRA_DATA]", txt)
            const m = {
              to: device.mail,
              subject: newSubject,
              message: newMessage,
              deviceCompanyGuid: device.guidCompany,
              deviceGuid: device.guidDevice,
              guidCompany: cmp.companyId,
              guidParent: device.guidParent,
            }
            mail.push(m)
          }
        })
      } else {
        mail = {
          to: item.to,
          subject: item.subject,
          message: item.message,
          guidCompany: cmp.companyId,
          guidParent: cmp.companyData && cmp.companyData.guidParent,
          deviceGuid: cmp.device.guid
        }
      }
      console.log('mail', mail)

      Vue.prototype.$api.sendMail(mail, function (res) {
        console.log('sendMail done', res)
        cmp.reload()
      })
    },
    doArchive: function () {
      this.updateArchiveState(1)
    },
    unArchive: function () {
      this.updateArchiveState(0)
    },
    updateArchiveState: function (isArchived) {
      if (this.isArchiving || !this.device || !this.device.guid) return

      this.isArchiving = true
      const payload = {...this.device, isArchived}
      Vue.prototype.$api.archiveDevice(this.device.guid, payload, this.onArchiveUpdated, this.onArchiveFailed)
    },
    updateItem: function () {
      if (this.isSaving || !this.device || !this.device.guid || !this.companyData || !this.companyData.guid) return

      this.isSaving = true
      Vue.prototype.$api.updateDevice(this.device.guid, this.device, this.onDeviceUpdated, this.onSaveFailed)
    },
    onDeviceUpdated: function (data) {
      console.log('onDeviceUpdated', data)
      Vue.prototype.$apiCompany.updateCompany(this.companyData.guid, this.companyData, this.onCompanyUpdated, this.onSaveFailed)
    },
    onCompanyUpdated: function (data) {
      console.log('onCompanyUpdated', data)
      this.isSaving = false
      this.$emit('reloadDevice', this.device.guid)
      this.reload()
    },
    onArchiveUpdated: function (data) {
      console.log('onArchiveUpdated', data)
      this.isArchiving = false
      this.$emit('reloadDevice', this.device.guid)
      this.reload()
    },
    onSaveFailed: function (error) {
      console.error('device save failed', error)
      this.isSaving = false
      this.isArchiving = false
      Vue.prototype.$eventHub.$emit('OnError', error)
    },
    onArchiveFailed: function (error) {
      console.error('device archive failed', error)
      this.isArchiving = false
      Vue.prototype.$eventHub.$emit('OnError', error)
    },
    isDeviceArchived: function () {
      return Number(this.device && this.device.isArchived) === 1
    },
    navigate: function (inc) {
      var newIndex = this.navState.index + inc
      if (newIndex<=0) newIndex = 0
      if (newIndex>=this.navState.list.length - 1) newIndex = this.navState.list.length - 1
      var item = this.navState.list[newIndex]
      this.navState.index = newIndex
      Vue.prototype.storage.saveState("SupportList", this.navState)
      this.$emit('reloadDevice', item.guid)
      Vue.prototype.$apiCompany.loadCompany(item.guidCompany, this.onGetData)
    },
    isAdmin: function () {
      return Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_CREATE', {})
    },
    sendEmail: function () {
      console.log('sendEmail')
      const cmp = this
      this.deviceList = [this.device]
      let devicePerCompany = {}
      devicePerCompany['' + this.device.guidCompany] = {
        name: cmp.companyData.name,
        mail: cmp.companyData.email,
        guid: cmp.device.guidCompany,
        guidDevice: cmp.device.guid,
        guidParent: cmp.companyData.guidParent,
        devices: [cmp.device]
      }
      const mail = {
        to: cmp.companyData.email,
        subject: '',
        message: '',
        extra: devicePerCompany
      }
      console.log('mail', mail, devicePerCompany)

      this.$refs.dlgEMail.open(mail)
    },
    onGetData(companyData) {
      console.log('companyData', companyData)
      this.companyData = companyData
      if (this.$refs.tableComments) {
        this.$refs.tableComments.reload()
      }
    },
    reload() {
      console.log('this.companyId', this.companyId)
      Vue.prototype.$apiCompany.loadCompany(this.companyId, this.onGetData)
      this.navState = Vue.prototype.storage.getState("SupportList")
    }
  },
  mounted() {
    this.reload()
  }
}
</script>

<style scoped>

</style>
